// Imports
  // React
  import React, { useContext} from 'react'
  import { Link } from 'react-router-dom'
  // Context
  import { CartContext } from '../context/CartContext'
  // Components
  import ItemCardCounter from "./ItemCardCounter"



// rafce

const CombosCard = ({item}) => {

  // Functions
  const { getItem } = useContext(CartContext);
  
  let itemInCart = getItem(item.name);
  
  // Counter
  let updatedCounter = 0;
  if(itemInCart) {
    updatedCounter = itemInCart.qty
  }
  
  // Stock
  let updatedStock = item.stock;
  if(itemInCart) {
    updatedStock = item.stock - itemInCart.qty
  }

  // Limit characters in description button
  const limitedDescription = () => {
    const description = item.description
    const shortDescription = description.substring(0 , 40)+"...  VER MÁS"
    if (description.length > 19){
      return shortDescription
    }
    else{
      return description
    }
  }


  // Component
  return (
    <>
      <div className='combos-card-image'>
        <span>Cód. {item.code}</span>
        <img src={item.picture} alt="Foto del Combo" />
      </div>
      <div className='item-card-info'>
        <div className='item-card-description'>
          <h2>{item.name}</h2>
          <Link to={`${item.id}`}>{limitedDescription()}</Link>
          <span>$ {item.price.toFixed(2)}</span>
        </div>
        <ItemCardCounter item={item} counter={updatedCounter} stock={updatedStock} />
      </div>
    </>
  )
}

export default CombosCard

